<script setup>
import { useStore } from 'vuex'

const store = useStore()
store.commit('initializeStore')
</script>

<template>
  <router-view/>
</template>